import { Fragment, useCallback, useContext, useEffect, useRef, useState } from "react";
import AuthContext from "../../../auth/AuthContext";
import CourseService from "../../../services/CourseService";
import VMService from "../../../services/VMService";
import AlertService from "../../../services/AlertService";
import './CyberRange.css'
import { Skeleton } from "primereact/skeleton";
import { useLocation } from 'react-router-dom';
// import VMControls from "./VMControls";
import GuacamoleControls from "./GuacamoleControls";
import SplitView from "./SplitView";
import CourseList from "./CourseList";
import { useLabActivity } from "./LabActivityContext";

const CyberRange = () => {
    const vmBootDuration = 50000;
    const vmBootRemaingTime = vmBootDuration / 1000;
    const [loading, setLoading] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [vmStarted, setVMStarted] = useState(false);
    const [vmText, setVMText] = useState("Start Lab / Stop Lab");
    const [vmUrl, setVMUrl] = useState();
    const [vmUrl1, setVMUrl1] = useState();
    const [vmUrl2, setVMUrl2] = useState();
    const [url, setUrl] = useState();
    const [username, setUsername] = useState();
    const [vmList, setVMList] = useState(false);
    const [isLocal, setIsLocal] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [splitView, setSplitView] = useState(false);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isParallel, setIsParallel] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [totalHours, setTotalHours] = useState();
    const [authToken, setAuthToken] = useState();
    const [consumedHours, setConsumedHours] = useState();
    const [remainingHours, setRemainingHours] = useState();
    const [password, setPassword] = useState();
    const [mappedCourses, setMappedCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState();
    const [labType, setLabType] = useState('LOCAL');
    const [totalTime, setTotalTime] = useState('00:00');
    const [iframeKey, setIframeKey] = useState(0);
    const [activePane, setActivePane] = useState('left');
    const [lastFocused, setLastFocused] = useState(null);
    const [vmStatus, setVmStatus] = useState('stopped');
    const [bootProgress, setBootProgress] = useState(0);
    const [currentStep, setCurrentStep] = useState('Initialize your virtual machine');
    const [restartStep, setRestartStep] = useState('Restart your virtual machine');
    const [timeRemaining, setTimeRemaining] = useState(vmBootRemaingTime);
    const msgs = useRef(null);
    const authContext = useContext(AuthContext);
    const [leftWidth, setLeftWidth] = useState('100%');
    const containerRef = useRef(null);
    const leftPaneRef = useRef(null);
    const rightPaneRef = useRef(null);
    const dividerRef = useRef(null);
    const leftIframeRef = useRef(null);
    const rightIframeRef = useRef(null);
    const singleIframeRef = useRef(null);
    const dragOverlayRef = useRef(null);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const isVmMode = queryParams.get("vmMode") === "true";
    const [checkingStatus, setCheckingStatus] = useState(false);
    // const vmTabRef = useRef(null);
    const stoppingRef = useRef(false);
    const vmStatusRef = useRef(vmStatus);
    const [isExpired, setIsExpired] = useState(false);
    const { remainingSeconds, setRemainingSeconds, idleStage, setIsLabRunning, setShowIdleWarning, showIdleWarning, warningSeconds } = useLabActivity();
    const HEARTBEAT_INTERVAL = Number(process.env.REACT_APP_LAB_HEARTBEAT_INTERVAL || 180000);
    const loadCoursesRef = useRef(null);
    const checkStatusRef = useRef(null);
    const startVMRef = useRef(null);
    const stopVMRef = useRef(null);
    const resetVMRef = useRef(null);
    const [restoringLab, setRestoringLab] = useState(true);



    const formatMMSS = (totalSeconds) => {

    const m = Math.floor(totalSeconds / 60);
    const s = totalSeconds % 60;

    return (
        String(m).padStart(2, "0") +
        ":" +
        String(s).padStart(2, "0")
    );
};



    const formatTime = (seconds) => {
        if (seconds < 60) return `${seconds}s`;
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}m ${secs}s`;
    };

    const formatHHMMSS = (totalSeconds) => {
        const h = Math.floor(totalSeconds / 3600);
        const m = Math.floor((totalSeconds % 3600) / 60);
        const s = totalSeconds % 60;

        return `${String(h).padStart(2, '0')}:` +
            `${String(m).padStart(2, '0')}:` +
            `${String(s).padStart(2, '0')}`;
    };

    useEffect(() => {
        if (isVmMode) return;

        const handleMessage = (event) => {
            if (event.data === "focus-me") {
                if (event.origin !== window.location.origin) return;
                if (event.data === "focus-me") window.focus();
            }
        };

        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, [isVmMode]);

    // Handle iframe loading
const attachVmActivityListeners = (iframeRef) => {

    try {

        const iframeDoc =
            iframeRef.contentWindow.document;

        const sendActivity = () => {
            window.postMessage("vm-activity", "*");
        };

        iframeDoc.addEventListener(
            "mousemove",
            sendActivity
        );

        iframeDoc.addEventListener(
            "keydown",
            sendActivity
        );

        iframeDoc.addEventListener(
            "click",
            sendActivity
        );

    } catch (err) {
        console.log("iframe activity access blocked");
    }
};

const handleIframeLoad = (type) => {

    if (type === 'single' && singleIframeRef.current) {

        singleIframeRef.current.focus();

        attachVmActivityListeners(singleIframeRef.current);

        try {
            singleIframeRef.current.contentWindow.postMessage('focus', '*');
        } catch (e) {
            console.log('Could not send focus message', e);
        }
    }

    if (type === 'parallel') {

        attachVmActivityListeners(leftIframeRef.current);
        attachVmActivityListeners(rightIframeRef.current);

        handlePaneFocus('left');
    }
};

    useEffect(() => {
        vmStatusRef.current = vmStatus;
    }, [vmStatus]);
    // Handle pane focus
    const handlePaneFocus = (pane) => {
        setActivePane(pane);
        setLastFocused(pane);
        setTimeout(() => {
            const iframe = pane === 'left'
                ? leftIframeRef.current
                : rightIframeRef.current;
            if (iframe) {
                iframe.focus();
                try {
                    iframe.contentWindow.postMessage('focus', '*');
                } catch (e) {
                    console.log('Could not send focus message to iframe', e);
                }
            }
        }, 50);
    };

    // Divider drag handling
    useEffect(() => {
        if (isParallel) {
            const divider = dividerRef.current;
            const overlay = dragOverlayRef.current;
            let isDragging = false;
            let startX = 0;
            let startLeftWidth = 0;
            const handleMouseDown = (e) => {
                if (e.target !== divider) return;
                isDragging = true;
                startX = e.clientX;
                startLeftWidth = leftPaneRef.current.offsetWidth;
                document.body.style.cursor = 'col-resize';
                divider.style.backgroundColor = '#888';
                overlay.style.display = 'block';
                if (leftIframeRef.current) leftIframeRef.current.style.pointerEvents = 'none';
                if (rightIframeRef.current) rightIframeRef.current.style.pointerEvents = 'none';
                e.preventDefault();
                e.stopPropagation();
            };

            const handleMouseMove = (e) => {
                if (!isDragging) return;
                const containerWidth = containerRef.current.offsetWidth;
                // const dividerWidth = divider.offsetWidth;
                // Calculate minimum and maximum widths (neither pane can go below 40%)
                const minLeftWidth = containerWidth * 0.3;  // Left pane minimum 40%
                const maxLeftWidth = containerWidth * 0.7;  // Left pane maximum 60% (right pane minimum 40%)
                const newLeftWidth = Math.max(
                    minLeftWidth,
                    Math.min(
                        startLeftWidth + (e.clientX - startX),
                        maxLeftWidth
                    )
                );
                leftPaneRef.current.style.width = `${newLeftWidth}px`;
                rightPaneRef.current.style.flex = '1 1 0';
            };

            const handleMouseUp = () => {
                if (!isDragging) return;
                isDragging = false;
                document.body.style.cursor = '';
                divider.style.backgroundColor = '#aaa';
                overlay.style.display = 'none';
                if (lastFocused) {
                    handlePaneFocus(lastFocused);
                } else {
                    handlePaneFocus('left');
                }
                setLeftWidth(leftPaneRef.current.style.width);
                setTimeout(() => {
                    if (leftIframeRef.current && rightIframeRef.current) {
                        leftIframeRef.current.style.width = '100%';
                        rightIframeRef.current.style.width = '100%';
                    }
                }, 50);
            };
            divider.addEventListener('mousedown', handleMouseDown);
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            return () => {
                divider.removeEventListener('mousedown', handleMouseDown);
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
            };
        }
    }, [isParallel, lastFocused]);

    const parseRemainingTimeToSeconds = (timeStr) => {
        if (!timeStr) return 0;

        let totalSeconds = 0;

        const hourMatch = timeStr.match(/(\d+(?:\.\d+)?)h/);
        const minuteMatch = timeStr.match(/(\d+)m/);

        if (hourMatch) {
            totalSeconds += parseFloat(hourMatch[1]) * 3600;
        }

        if (minuteMatch) {
            totalSeconds += parseInt(minuteMatch[1]) * 60;
        }

        return Math.floor(totalSeconds);
    };

    useEffect(() => {
        if (vmStatus === "running") {
            setShowIdleWarning(false);
        }
    }, [vmStatus, setShowIdleWarning]);



    useEffect(() => {
        if (vmStatus === "running" && remainingSeconds > 0) {
            setIsLabRunning(true);
        } else {
            setIsLabRunning(false);
        }
    }, [vmStatus, remainingSeconds, setIsLabRunning]);


    useEffect(() => {
        setTotalTime(formatHHMMSS(remainingSeconds));
    }, [remainingSeconds]);

 useEffect(() => {
  const controller = new AbortController();

const restoreLabState = async () => {

  const savedCourse = localStorage.getItem("running_lab_course");

  if (!savedCourse) {
    setRestoringLab(false);
    return;
  }

  try {

    const courseObj = JSON.parse(savedCourse);
    setSelectedCourse(courseObj);

    const result = await VMService.statusVM(
      courseObj.id,
      authContext,
      controller.signal
    );

    if (controller.signal.aborted) return;

    if (result?.isSuccess) {

      if (result.data?.isExpired) {

        setIsExpired(true);
        setLabType(result.data.status);
        setVMStarted(false);
        setVmStatus("stopped");
        setTotalHours(result.data.totalHours);
        setConsumedHours(result.data.consumedHours);
        setRemainingHours(result.data.remainingHours);

        const remainingSec =
          parseRemainingTimeToSeconds(
            result.data.remainingHours
          );

        setRemainingSeconds(remainingSec);

        return;
      }

      if (result.data?.isVMRunning) {

        const remainingSec =
          parseRemainingTimeToSeconds(
            result.data.remainingHours
          );

        setVmStatus("running");
        setVMStarted(true);
        setLabType(result.data.status);
        setCurrentStep("VM Ready!");
        setRemainingSeconds(remainingSec);
        setIsLabRunning(true);
        setTotalHours(result.data.totalHours);
      } else {
        localStorage.removeItem("running_lab_course");
        setVMStarted(false);
        setVmStatus("stopped");
        setSelectedCourse(null);
      }
    }
  } finally {

    setRestoringLab(false);
  }
};
  restoreLabState();

  return () => controller.abort();

}, [authContext]);

    // Keyboard shortcuts
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (isParallel) {
                if (e.ctrlKey || e.metaKey) {
                    if (e.key === '1') {
                        handlePaneFocus('left');
                        e.preventDefault();
                    } else if (e.key === '2') {
                        handlePaneFocus('right');
                        e.preventDefault();
                    }
                }
                else if (e.altKey) {
                    if (e.key === 'ArrowLeft') {
                        handlePaneFocus('left');
                        e.preventDefault();
                    } else if (e.key === 'ArrowRight') {
                        handlePaneFocus('right');
                        e.preventDefault();
                    }
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isParallel]);

    // Message listener for Guacamole
    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data === 'guacamole-connected' || event.data === 'guac-request-focus') {
                if (!isParallel && singleIframeRef.current) {
                    singleIframeRef.current.focus();
                }
                else if (isParallel) {
                    const leftWindow = leftIframeRef.current?.contentWindow;
                    const rightWindow = rightIframeRef.current?.contentWindow;

                    if (event.source === leftWindow) {
                        handlePaneFocus('left');
                    } else if (event.source === rightWindow) {
                        handlePaneFocus('right');
                    }
                }
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [isParallel]);

    // Initialize parallel mode
    useEffect(() => {
        setLeftWidth('100%');
        if (isParallel) {
            setLeftWidth('50%');
            setVMUrl1(`${url}/#/client/${vmList[0].connectionId}?token=${authToken}`);
            setVMUrl2(`${url}/#/client/${vmList[1].connectionId}?token=${authToken}`);
            setTimeout(() => {
                setIframeKey(prev => prev + 1);
                handlePaneFocus('left');
            }, 10);
        } else {
            setTimeout(() => {
                if (singleIframeRef.current) {
                    singleIframeRef.current.focus();
                }
            }, 100);
        }
    }, [isParallel, authToken, vmList, url]);

const checkVMStatus = useCallback(
  async (m) => {
    if (checkStatusRef.current) {
      checkStatusRef.current.abort();
    }
    const controller = new AbortController();
    checkStatusRef.current = controller;

    setHasError(false);
    setCheckingStatus(true);

    try {
      const result = await VMService.statusVM(
        m.id,
        authContext,
        controller.signal
      );

      if (controller.signal.aborted) return;

      if (result) {
        setProcessing(false);
        if (result.isSuccess) {
          setCheckingStatus(false);
          if (result.data.isExpired === true || parseRemainingTimeToSeconds(result.data.remainingHours) <= 0) {
            setIsExpired(true);
            setLabType(result.data.status || "GUACAMOLE");
            setVMStarted(false);
            setVmStatus("stopped");
            setTotalHours(result.data.totalHours);
            setConsumedHours(result.data.consumedHours);
            setRemainingHours(result.data.remainingHours);
            const remainingSec = parseRemainingTimeToSeconds(result.data.remainingHours);
            setRemainingSeconds(remainingSec);
            //  setVMText(`Given Lab time is fully utilized. You won't be access it further`);
            return;
          }
          else if (result.data.status === "LOCAL") {
            setLabType("LOCAL");
            setVMStarted(true);
            setIsLocal(true);
            setVMUrl(result.data.shareableLink);
            setUsername(result.data.userName);
            setPassword(result.data.password);
            setTotalHours(result.data.totalHours);
            setConsumedHours(result.data.consumedHours);
            setRemainingHours(result.data.remainingHours);
          }
          else if (result.data.status === "GUACAMOLE") {
            setLabType("GUACAMOLE");
            setVMStarted(result.data.isVMRunning);
            setVmStatus(result.data.isVMRunning ? 'running' : 'stopped');
            setCurrentStep(result.data.isVMRunning ? 'VM Ready' : 'Initialize your virtual machine');
            setIsLocal(false);
            setVMUrl(result.data.shareableLink);
            setUsername(result.data.userName);
            setPassword(result.data.password);
            const remainingSec = parseRemainingTimeToSeconds(result.data.remainingHours);
            const consumedSec = parseRemainingTimeToSeconds(result.data.consumedHours);
            setRemainingSeconds(remainingSec);
            setTotalTime(formatHHMMSS(remainingSec));
            setTotalHours(result.data.totalHours);
            setConsumedHours(result.data.consumedHours);
            setRemainingHours(result.data.remainingHours);
          }
          else if (result.data.status === "VM running") {
            setLabType("AZURE");
            setVMStarted(true);
            setVMUrl(result.data.shareableLink);
            setUsername(result.data.userName);
            setPassword(result.data.password);
            setTotalHours(result.data.totalHours);
            setConsumedHours(result.data.consumedHours);
            setRemainingHours(result.data.remainingHours);
          }
        } else {
          setHasError(true);
          if (msgs.current) {
            msgs.current.clear();
            msgs.current.show([
              { sticky: true, severity: 'error', summary: 'Error', detail: 'Something went wrong!! Please contact support!!', closable: false },
            ]);
          }
        }
      } else {
        setHasError(true);
        setCheckingStatus(false);
        setProcessing(false);
        if (msgs.current) {
          msgs.current.clear();
          msgs.current.show([
            { sticky: true, severity: 'error', summary: 'Error', detail: 'Something went wrong!! Please contact support!!', closable: false },
          ]);
        }
      }
    } catch (err) {
      if (err.name === "AbortError") return;
      setHasError(true);
      setCheckingStatus(false);
    }
  },
  [authContext]
);

    const openLabInline = (course) => {
        setSelectedCourse(course);
        checkVMStatus(course);
    };
const loadCourses = useCallback(async () => {
  if (loadCoursesRef.current) {
    loadCoursesRef.current.abort();
  }
  const controller = new AbortController();
  loadCoursesRef.current = controller;

  setLoading(true);
  try {
    const data = await CourseService.GetMappedCourses(
      authContext,
      controller.signal
    );

    if (controller.signal.aborted) return;

    if (data.isSuccess) {
      setMappedCourses(data.data);
    } else {
      AlertService.error(data.errorMessage);
    }
  } catch (err) {
    if (err.name === "AbortError") return;
    AlertService.error("Failed to load courses");
  } finally {
    if (!controller.signal.aborted) setLoading(false);
  }
}, [authContext]);

    useEffect(() => {
        if (!isVmMode) {
            loadCourses();
        }
    }, [loadCourses, authContext, isVmMode]);


    useEffect(() => {
        if (vmStatus === 'starting') {
            const totalDuration = vmBootDuration; // 50 seconds
            const interval = 100;
            const increment = 100 / (totalDuration / interval);
            let currentProgress = 0;
            const timer = setInterval(() => {
                currentProgress += increment;
                setBootProgress(Math.min(currentProgress, 100));
                setTimeRemaining(
                    Math.max(0, Math.ceil((100 - currentProgress) * (vmBootRemaingTime / 100)))
                );
                if (currentProgress >= 100) {
                    clearInterval(timer);
                    setTimeout(() => {
                        setProcessing(false);
                        setVMStarted(true);
                        setCurrentStep('VM Ready!');
                        setVmStatus('running');
                        AlertService.success("Lab environment is ready. Click “Go to VM” to access your session");
                    }, 500);
                }
            }, interval);

            return () => clearInterval(timer);
        }
        if (vmStatus === 'restarting') {
            const totalDuration = vmBootDuration;
            const interval = 100;
            const increment = 100 / (totalDuration / interval);

            let currentProgress = 0;

            const timer = setInterval(() => {
                currentProgress += increment;

                setBootProgress(Math.min(currentProgress, 100));
                setTimeRemaining(
                    Math.max(0, Math.ceil((100 - currentProgress) * (vmBootRemaingTime / 100)))
                );

                if (currentProgress >= 100) {
                    clearInterval(timer);
                    setTimeout(() => {
                        setProcessing(false);
                        setVMStarted(true);
                        setRestartStep('Restart your virtual machine');
                        setVmStatus('running');
                        AlertService.success("Lab restarted successfully!!");
                    }, 500);
                }
            }, interval);

            return () => clearInterval(timer);
        }
    }, [vmStatus, vmBootRemaingTime]);

  const startVM = async (e) => {
  e.preventDefault();

  if (startVMRef.current) {
    startVMRef.current.abort();
  }
  const controller = new AbortController();
  startVMRef.current = controller;

  setProcessing(true);
  setVMStarted(false);
  setVmStatus('starting');
  setBootProgress(0);
  setTimeRemaining(vmBootRemaingTime);
  setCurrentStep('Initializing VM...');
  setVMText("Starting...");

  try {
    const result = await VMService.startVM(
      selectedCourse.id,
      authContext,
      controller.signal
    );

    if (controller.signal.aborted) return;

    if (result.isSuccess === false) {
      setVMStarted(false);
      setVmStatus('stopped');
      setCurrentStep('Initialize your virtual machine');
      AlertService.error(result.errorMessage);
    } else {
      localStorage.setItem(
        "running_lab_course",
        JSON.stringify(selectedCourse)
      );
    }
  } catch (err) {
    if (err.name === "AbortError") return;
    AlertService.error("Failed to start VM");
  }
};

    const autoStopVM = useCallback(async () => {
        const course =
            selectedCourse ||
            JSON.parse(localStorage.getItem("running_lab_course") || "{}");

        if (!course?.id) return;
        if (stoppingRef.current) return;
        stoppingRef.current = true;

        setProcessing(true);
        setVMText("Stopping...");

        const result = await VMService.stopVM(course.id, authContext);
        localStorage.removeItem("running_lab_course");
        localStorage.removeItem("lab_end_time");
        sessionStorage.removeItem("vm_data");
        localStorage.setItem("vm_event", JSON.stringify({
            type: "STOP",
            time: Date.now()
        }));
        setIsLabRunning(false);
        setShowIdleWarning(false);

        setProcessing(false);

        if (result.isSuccess) {
            setVmStatus('stopped');
            setVMStarted(false);
            setShowIdleWarning(false);
            setCurrentStep('Initialize your virtual machine');
            if (result.data?.remainingHours) {
                const seconds = parseRemainingTimeToSeconds(result.data.remainingHours);
                setRemainingSeconds(seconds);
            }
        if (isVmMode) {
            window.close();
        } else {
            AlertService.success("Lab session terminated because VM tab was closed.");
        }
        } else {
            AlertService.error(result.errorMessage);
        }

        stoppingRef.current = false;
    }, [selectedCourse, authContext, setShowIdleWarning, isVmMode]);

    useEffect(() => {
        if (remainingSeconds <= 0 && vmStatus === 'running') {
            setIsExpired(true);
            autoStopVM();
        }
    }, [remainingSeconds, vmStatus, autoStopVM]);

    useEffect(() => {
        if (idleStage === "shutdown" && vmStatus === "running") {
          autoStopVM();
        }
    }, [idleStage, vmStatus, autoStopVM]);

  const stopVM = async (e) => {
  if (stoppingRef.current) return;
  stoppingRef.current = true;
  e.preventDefault();

  if (stopVMRef.current) {
    stopVMRef.current.abort();
  }
  const controller = new AbortController();
  stopVMRef.current = controller;

  try {
    setVMStarted(false);
    setProcessing(true);
    setVMText("Stopping...");
    setShowIdleWarning(false);

    const result = await VMService.stopVM(
      selectedCourse.id,
      authContext,
      controller.signal
    );

    if (controller.signal.aborted) return;

    localStorage.removeItem("running_lab_course");
    localStorage.removeItem("lab_end_time");
    sessionStorage.removeItem("vm_data");
    localStorage.setItem("vm_event", JSON.stringify({
      type: "STOP",
      time: Date.now()
    }));

    setVMText("Start Lab / Stop Lab");
    setProcessing(false);

    if (result.isSuccess) {
      setVmStatus('stopped');
      setCurrentStep('Initialize your virtual machine');
      if (result.data?.remainingHours) {
        const seconds = parseRemainingTimeToSeconds(result.data.remainingHours);
        setRemainingSeconds(seconds);
        setTotalTime(formatHHMMSS(seconds));
      }
      AlertService.success("Lab stopped successfully!!");
    } else {
      AlertService.error(result.errorMessage);
    }
  } catch (error) {
    if (error.name === "AbortError") return;
    console.error(error);
  } finally {
    if (!controller.signal.aborted) setProcessing(false);
    stoppingRef.current = false;
  }
};
const resetVM = async (e) => {
  e.preventDefault();

    if (stoppingRef.current) return; 
  stoppingRef.current = true;    

  if (resetVMRef.current) {
    resetVMRef.current.abort();
  }
  const controller = new AbortController();
  resetVMRef.current = controller;

  setVMStarted(false);
  setProcessing(true);
  setVMText("Stopping...");
  setVmStatus('restarting');
  setBootProgress(0);
  setTimeRemaining(vmBootRemaingTime);
  setRestartStep('Restarting VM...');
  setVMText("Restarting...");

  try {
    const result = await VMService.resetVM(
      selectedCourse.id,
      authContext,
      controller.signal
    );

    if (controller.signal.aborted) return;

    localStorage.setItem("vm_event", JSON.stringify({
      type: "RESTART",
      time: Date.now()
    }));

    if (result.isSuccess === false) {
      setVMStarted(false);
      setVmStatus('stopped');
      setCurrentStep('Restart your virtual machine');
      AlertService.error(result.errorMessage);
    }
  } catch (err) {
    if (err.name === "AbortError") return;
    AlertService.error("Failed to restart VM");
  } finally {
    stoppingRef.current = false;
  }
};

useEffect(() => {
  return () => {
    loadCoursesRef.current?.abort();
    checkStatusRef.current?.abort();
    startVMRef.current?.abort();
    stopVMRef.current?.abort();
    resetVMRef.current?.abort();
  };
}, []);

useEffect(() => {

   if (restoringLab) return;
    const handleStorage = (event) => {
        if (event.key !== "vm_event") return;

        const data = JSON.parse(event.newValue || "{}");

        // VM MODE TAB
        if (isVmMode) {
if (data.type === "STOP") {

    setVMStarted(false);
    setVmStatus("stopped");
    setSplitView(false);
    setIsLabRunning(false);
    setShowIdleWarning(false);
    window.close();
}

            if (data.type === "RESTART") {
                setVmStatus("starting");
                setBootProgress(0);
                setTimeRemaining(vmBootRemaingTime);
            }

            return;
        }

        // ADD THIS
if (data.type === "STOP") {
    setVMStarted(false);
    setVmStatus("stopped");
    setSplitView(false);
    setIsLabRunning(false);
    setShowIdleWarning(false);

    AlertService.success(
        "Lab session terminated due to inactivity. Select “Start Lab” to relaunch."
    );
}


if (
    data.type === "TAB_CLOSED" &&
    localStorage.getItem("running_lab_course")
) {

    setTimeout(() => {

        // refresh na vm tab still open irukum
        const vmTabExists = window.open(
            "",
            "CYBER_VM_TAB"
        );

        if (vmTabExists && !vmTabExists.closed) {
            return;
        }

        autoStopVM();

    }, 1000);
}
        };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
    }, [autoStopVM, isVmMode, vmBootRemaingTime, restoringLab]);

    // VM mode tab
 useEffect(() => {

    if (!isVmMode) return;

    const handleBeforeUnload = () => {

        localStorage.setItem(
            "vm_event",
            JSON.stringify({
                type: "TAB_CLOSED",
                time: Date.now()
            })
        );
    };

    window.addEventListener(
        "beforeunload",
        handleBeforeUnload
    );

    return () => {
        window.removeEventListener(
            "beforeunload",
            handleBeforeUnload
        );
    };

}, [isVmMode]);

    const loadVMList = async (e) => {
        e.preventDefault();
        setProcessing(true);
        setHasError(false);

        const data = await VMService.getVMList(selectedCourse.id, authContext);
        setProcessing(false);

        if (data.isSuccess) {

            sessionStorage.setItem("vm_data", JSON.stringify({
                url: data.data.url,
                token: data.data.token,
                list: data.data.list,
                remainingSeconds: remainingSeconds,
            }));

          const vmTab = window.open(
    "/#/bay?vmMode=true",
    "CYBER_VM_TAB"
);

if (vmTab) {
    vmTab.focus();
}
        } else {
            setHasError(true);
            AlertService.error(data.errorMessage);
        }
    };

// useEffect(() => {

//     if (!selectedCourse?.id) return;

//     const interval = setInterval(async () => {

//         const result = await VMService.statusVM(
//             selectedCourse.id,
//             authContext
//         );

//         if (!result?.isSuccess) return;

//         // VM unexpectedly stopped
//         if (
//             vmStatus === "running" &&
//             result.data?.isVMRunning === false
//         ) {

//             localStorage.setItem(
//                 "vm_event",
//                 JSON.stringify({
//                     type: "STOP",
//                     time: Date.now(),
//                 })
//             );

//             setVMStarted(false);
//             setVmStatus("stopped");
//             setSplitView(false);
//             setIsLabRunning(false);
//             setShowIdleWarning(false);

//             localStorage.removeItem("running_lab_course");
//             localStorage.removeItem("lab_end_time");

//             if (isVmMode) {
//                 window.close();
//             }

//             return;
//         }

//         // VM unexpectedly started
//         if (
//      vmStatus === "stopped" &&
//     result.data?.isVMRunning === true
//         ) {
//             setProcessing(false);
//             setVMStarted(true);
//             setVmStatus("running");
//             setCurrentStep("VM Ready!");
//             setIsLabRunning(true);

//             localStorage.setItem(
//                 "running_lab_course",
//                 JSON.stringify(selectedCourse)
//             );
//         }

//     }, 15000);

//     return () => clearInterval(interval);

// }, [
//     vmStatus,
//     selectedCourse,
//     authContext,
//     isVmMode,
// ]);

   useEffect(() => {

    if (!isVmMode) return;

    const runningCourse =
        localStorage.getItem("running_lab_course");

    if (!runningCourse) {

        sessionStorage.removeItem("vm_data");

        window.close();

        return;
    }

    const stored = sessionStorage.getItem("vm_data");

    if (stored) {

        const data = JSON.parse(stored);

        setIsParallel(false);
        setLeftWidth('100%');
        setIsCollapsed(false);
        setIsFullScreen(true);

        setUrl(data.url);
        setAuthToken(data.token);
        setVMList(data.list);

        if (data.remainingSeconds) {
            setRemainingSeconds(data.remainingSeconds);
            setIsLabRunning(true);
            setVmStatus("running");
        }

        setVMUrl(
            `${data.url}/#/client/${data.list[0].connectionId}?token=${data.token}`
        );

        setSplitView(true);
    }

}, [isVmMode]);



    const focusIframe = () => {
    setTimeout(() => {
        if (!isParallel && singleIframeRef.current) {
            singleIframeRef.current.focus();
            try {
                singleIframeRef.current.contentWindow.postMessage('focus', '*');
            } catch {}
        } else if (isParallel) {
            handlePaneFocus(activePane || 'left');
        }
    }, 200);
};

    const showVM = async (e, vm) => {
        e.preventDefault();
        setIsParallel(false);
        setLeftWidth('100%');
        setVMUrl1(undefined);
        setVMUrl(`${url}/#/client/${vm.connectionId}?token=${authToken}`);
        focusIframe();
    }

    const refreshIframe = async () => {
        setIframeKey(prev => prev + 1);
        setTimeout(() => {
            if (!isParallel && singleIframeRef.current) {
                singleIframeRef.current.focus();
            } else if (isParallel && lastFocused) {
                handlePaneFocus(lastFocused);
            }
        }, 500);
    };

    const toggleFullscreen = async () => {
        setIsFullScreen(!isFullScreen);
    };

const heartbeatRef = useRef(false);

useEffect(() => {

    if (vmStatus !== "running") {
        heartbeatRef.current = false;
        return;
    }

    heartbeatRef.current = true;

    const interval = setInterval(async () => {

        if (!heartbeatRef.current) return;

        const course = JSON.parse(localStorage.getItem("running_lab_course") || "{}");
        const vmId = course?.id;

        if (!vmId) return;

        console.log("Heartbeat sent at", new Date().toLocaleTimeString());

        try {
          await VMService.updateTime(vmId, authContext);
        } catch (err) {
            console.error("Heartbeat error", err);
        }

    }, HEARTBEAT_INTERVAL);

    return () => {
        heartbeatRef.current = false;
        clearInterval(interval);
    };

}, [vmStatus, authContext, HEARTBEAT_INTERVAL]);

    return (
        <Fragment>
            <div className="mt-3">
                {loading && !selectedCourse && (

                    <div className="row g-4 mb-4 me-3">
                        {Array.from({ length: 8 }).map((_, idx) => (
                            <div key={idx} className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                <div className="card border-0 shadow p-3 h-100 d-flex flex-row align-items-center gap-3 ms-3">
                                    <Skeleton shape="circle" size="3rem" className="flex-shrink-0" />
                                    <div className="flex-grow-1">
                                        <Skeleton width="80%" height="1.2rem" />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                {!loading && (
                    <>

                        {checkingStatus && selectedCourse && (
                            <div className="d-flex justify-content-center gap-5 p-3">
                                {[25, 25, 25, 25].map((width, index) => (
                                    <div
                                        key={index}
                                        className="text-center"
                                        style={{ width: `${width}%` }}
                                    >
                                        <div className="vm-container shadow">
                                            <center className="mb-3">
                                                <Skeleton size="4rem" shape="circle" />
                                            </center>
                                            <center className="mb-3">
                                                <Skeleton width="80%" height="2.7rem" />
                                            </center>
                                            <center className="mb-3">
                                                <Skeleton width="100%" height="2rem" />
                                            </center>
                                            <center className="mb-2">
                                                <Skeleton width="90%" height="2.7rem" />
                                            </center>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </>
                )}
                {!loading && !checkingStatus && (
                    <>
                        {!isVmMode && splitView === false && hasError === false &&
                            <>
                                {!selectedCourse && mappedCourses.length === 0 && (
                                    <div className="row m-0 pl-3 pr-3">
                                        <div className="col-12 text-center">Labs are yet to be assigned</div>
                                    </div>
                                )}
                                {!restoringLab &&
 vmStatus !== "running" &&
 !selectedCourse &&
 mappedCourses.length > 0 && (
                                    <CourseList
                                        mappedCourses={mappedCourses}
                                        openLabInNewTab={openLabInline}
                                    />
                                )}
                                {/* {selectedCourse !== undefined && selectedCourse !== null && selectedCourse.courseId > 0 && labType !== 'GUACAMOLE' && (
                                <VMControls vmStarted={vmStarted} isLocal={isLocal} hasError={hasError} vmText={vmText} startVM={startVM} stopVM={stopVM} vmUrl={vmUrl}
                                 username={username} password={password} totalHours={totalHours} consumedHours={consumedHours} remainingHours={remainingHours} />
                            )} */}
                                {selectedCourse !== undefined && selectedCourse !== null && selectedCourse.courseId > 0 && labType === 'GUACAMOLE' && (
                                    <GuacamoleControls totalTime={totalTime} isExpired={isExpired} remainingSeconds={remainingSeconds}   consumedHours={consumedHours} vmStarted={vmStarted} processing={processing} totalAllocatedSeconds={parseRemainingTimeToSeconds(totalHours)} vmStatus={vmStatus} bootProgress={bootProgress} timeRemaining={timeRemaining} currentStep={currentStep} restartStep={restartStep} startVM={startVM} stopVM={stopVM} resetVM={resetVM} loadVMList={loadVMList} formatTime={formatTime} />
                                )}
                            </>}
                        {splitView && hasError === false &&
                            <SplitView isFullScreen={isFullScreen} isCollapsed={isCollapsed} totalTime={totalTime} focusIframe={focusIframe} 
                                setIsCollapsed={setIsCollapsed} setSplitView={setSplitView} vmList={vmList}
                                showVM={showVM} setIsParallel={setIsParallel} refreshIframe={refreshIframe}
                                toggleFullscreen={toggleFullscreen} isParallel={isParallel} containerRef={containerRef}
                                dragOverlayRef={dragOverlayRef} activePane={activePane} leftPaneRef={leftPaneRef} leftWidth={leftWidth} handlePaneFocus={handlePaneFocus} leftIframeRef={leftIframeRef} iframeKey={iframeKey} vmUrl1={vmUrl1} dividerRef={dividerRef}
                                rightPaneRef={rightPaneRef} rightIframeRef={rightIframeRef} vmUrl2={vmUrl2}
                                vmUrl={vmUrl} singleIframeRef={singleIframeRef} handleIframeLoad={handleIframeLoad}
                            />
                        }
                        {
                            hasError &&
                            <div className="p-message p-component p-message-error p-message-enter-done" >
                                <div className="p-message-wrapper">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="p-icon p-message-icon">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7 14C5.61553 14 4.26215 13.5895 3.11101 12.8203C1.95987 12.0511 1.06266 10.9579 0.532846 9.67879C0.00303296 8.3997 -0.13559 6.99224 0.134506 5.63437C0.404603 4.2765 1.07129 3.02922 2.05026 2.05026C3.02922 1.07129 4.2765 0.404603 5.63437 0.134506C6.99224 -0.13559 8.3997 0.00303296 9.67879 0.532846C10.9579 1.06266 12.0511 1.95987 12.8203 3.11101C13.5895 4.26215 14 5.61553 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14ZM7 1.16667C5.84628 1.16667 4.71846 1.50879 3.75918 2.14976C2.79989 2.79074 2.05222 3.70178 1.61071 4.76768C1.16919 5.83358 1.05367 7.00647 1.27876 8.13803C1.50384 9.26958 2.05941 10.309 2.87521 11.1248C3.69102 11.9406 4.73042 12.4962 5.86198 12.7212C6.99353 12.9463 8.16642 12.8308 9.23232 12.3893C10.2982 11.9478 11.2093 11.2001 11.8502 10.2408C12.4912 9.28154 12.8333 8.15373 12.8333 7C12.8333 5.45291 12.2188 3.96918 11.1248 2.87521C10.0308 1.78125 8.5471 1.16667 7 1.16667ZM4.66662 9.91668C4.58998 9.91704 4.51404 9.90209 4.44325 9.87271C4.37246 9.84333 4.30826 9.8001 4.2544 9.74557C4.14516 9.6362 4.0838 9.48793 4.0838 9.33335C4.0838 9.17876 4.14516 9.0305 4.2544 8.92113L6.17553 7L4.25443 5.07891C4.15139 4.96832 4.09529 4.82207 4.09796 4.67094C4.10063 4.51982 4.16185 4.37563 4.26872 4.26876C4.3756 4.16188 4.51979 4.10066 4.67091 4.09799C4.82204 4.09532 4.96829 4.15142 5.07887 4.25446L6.99997 6.17556L8.92106 4.25446C9.03164 4.15142 9.1779 4.09532 9.32903 4.09799C9.48015 4.10066 9.62434 4.16188 9.73121 4.26876C9.83809 4.37563 9.89931 4.51982 9.90198 4.67094C9.90464 4.82207 9.84855 4.96832 9.74551 5.07891L7.82441 7L9.74554 8.92113C9.85478 9.0305 9.91614 9.17876 9.91614 9.33335C9.91614 9.48793 9.85478 9.6362 9.74554 9.74557C9.69168 9.8001 9.62748 9.84333 9.55669 9.87271C9.4859 9.90209 9.40996 9.91704 9.33332 9.91668C9.25668 9.91704 9.18073 9.90209 9.10995 9.87271C9.03916 9.84333 8.97495 9.8001 8.9211 9.74557L6.99997 7.82444L5.07884 9.74557C5.02499 9.8001 4.96078 9.84333 4.88999 9.87271C4.81921 9.90209 4.74326 9.91704 4.66662 9.91668Z" fill="currentColor"></path>
                                    </svg>
                                    <span className="p-message-summary">Error</span>
                                    <span class="p-message-detail">Something went wrong!! Please contact support!!</span>
                                </div>
                            </div>
                        }
                    </>
                )
                }
            </div>
{(
   showIdleWarning &&
   idleStage === "warning" &&
   (
      location.pathname.startsWith("/bay") ||
      isVmMode
   )
) && (
                <div
style={{
    position: "fixed",
    ...(isVmMode
        ? {
              top: "20px",
              left: "50%",
          }
        : {
              bottom: "20px",
              left: "60%",
          }),

    transform: "translateX(-50%)",
    backgroundColor: "#fdecea",
    color: "#d32f2f",
    padding: "8px 14px",
    borderRadius: "20px",
    fontSize: "1rem",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    gap: "6px",
    zIndex: 999999,
    pointerEvents: "none",
    whiteSpace: "nowrap",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
}}
                >
                    <span style={{ fontSize: "0.9rem" }}>⚠</span>
                  Lab session is inactive. It will automatically shut down in{" "}
<strong>{formatMMSS(warningSeconds)}</strong>
                </div>
            )}
        </Fragment >
    );
};

export default CyberRange;